import { defineStore } from 'pinia'

import {
  AuthService,
  serviceFactory,
  TeamService,
  UserService,
  WorkspaceService,
} from '@blueprint/frontend-basics'

import {
  appId,
  backendURL,
  keycloakClientId,
  keycloakRealm,
  keycloakURL,
} from '@/helpers/config.helper.ts'
import { TaleService } from '@/services/tale.service.ts'
import { ShopService } from '@/services/shop.service.ts'

export const useServiceStore = defineStore('serviceStore', {
  state: () => ({}),

  getters: {
    authService(): AuthService {
      return serviceFactory.getService<AuthService>(
        'authService',
        AuthService,
        keycloakURL,
        keycloakRealm,
        keycloakClientId,
        appId,
      )
    },
    shopService(): ShopService {
      return serviceFactory.getService<ShopService>(
        'shopService',
        ShopService,
        this,
        this.authService,
        backendURL,
      )
    },
    taleService(): TaleService {
      return serviceFactory.getService<TaleService>(
        'taleService',
        TaleService,
        this,
        this.authService,
        backendURL,
      )
    },
    userService(): UserService {
      return serviceFactory.getService<UserService>(
        'userService',
        UserService,
        this,
        this.authService,
        backendURL,
      )
    },
    teamService(): TeamService {
      return serviceFactory.getService<TeamService>(
        'teamService',
        TeamService,
        this,
        this.authService,
        backendURL,
      )
    },
    workspaceService(): WorkspaceService {
      return serviceFactory.getService<WorkspaceService>(
        'workspaceService',
        WorkspaceService,
        this,
        this.authService,
        backendURL,
      )
    },
  },

  actions: {},
})
